import { ReactNode, Suspense } from 'react';
import { matchPath } from 'react-router';

import { NsxHeader } from 'components/common/nsx-header/NsxHeader';
import { AuthProvider } from 'components/common/auth-provider/AuthProvider';
import { NsStopgap } from 'components/common/ns-stopgap/NsStopgap';

type Route = {
  path: string;
  hasFooter?: boolean;
  requiresLogin?: boolean;
  noIndex?: boolean;
  name: string;
};

type RouteScreenProps = {
  route: Route;
  children?: ReactNode;
  isLoginEnabled?: boolean;
};

export const RouteScreen = (props: RouteScreenProps) => {
  const {
    route: { path, hasFooter, requiresLogin, noIndex },
    children,
    isLoginEnabled
  } = props;
  const authEnabled = requiresLogin && isLoginEnabled;

  const isLoading = !matchPath(
    `${import.meta.env.VITE_PATH_PREFIX || ''}${path}`,
    window.location.pathname
  );

  return (
    <>
      {noIndex && <meta name="robots" content="noindex" />}

      <AuthProvider enabled={authEnabled}>
        <NsxHeader route={props.route} />
        <main id="#content">
          <div hidden={!isLoading}>
            <NsStopgap />
          </div>
          <div hidden={isLoading}>
            <Suspense fallback={<NsStopgap />}>{children}</Suspense>
          </div>
        </main>
        {hasFooter && <nsx-footer />}
      </AuthProvider>
    </>
  );
};
